import React from "react";
import { useNavigate } from "react-router-dom";
import './responseMessage.css';

const Success = () => {
  const navigate = useNavigate();

  return (
    <div className="response-container success">
      <h2>¡Pago exitoso! 🎉</h2>
      <p>Gracias por tu compra. En breve recibirás acceso a tu curso.</p>
      <button className="response-btn" onClick={() => navigate('/')}>Volver al inicio</button>
    </div>
  );
};

export default Success;
